import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Usuario/obtenerCentrosUsuario`, method: 'GET', body: null, token: token})
}
